/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createIllustration } from '@jira/illustrations__illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@jira/illustrations__illustration/src/ui/types.tsx';
import srcDark from '../../assets/bug-and-task-cards-in-a-column.svg'; // eslint-disable-line jira/import/no-duplicates
import srcLight from '../../assets/bug-and-task-cards-in-a-column.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

const viewBox: SVGViewBox = [0, 0, 448, 334];
export { viewBox };
